// Imagen del sitio que se adapta sola: el servidor genera la versión del tamaño justo para cada pantalla (AVIF o WebP)
// y la guarda en caché. Nadie tiene que preparar fotos chicas a mano; también sirve con las fotos que suben los proveedores.
// Se usa igual que <img>; `sizes` dice qué tan ancha se ve (por defecto, todo el ancho de la pantalla).
import type { ComponentProps } from "react";

const ANCHOS = [256, 384, 640, 828, 1080, 1200, 1920];
const optimizable = (src: string) => src.startsWith("/") && !src.startsWith("//") && !/\.svg($|\?)/i.test(src) && !src.includes("?");

export const urlLigera = (src: string, ancho: number) => `/_next/image?url=${encodeURIComponent(src)}&w=${ancho}&q=75`;

export function Img({ src, sizes = "100vw", alt = "", ...resto }: Omit<ComponentProps<"img">, "src"> & { src?: string }) {
  if (!src || process.env.NEXT_PUBLIC_EXPORT === "1" || !optimizable(src)) return <img src={src} alt={alt} sizes={sizes} {...resto} />;
  return <img src={urlLigera(src, 1080)} srcSet={ANCHOS.map((w) => `${urlLigera(src, w)} ${w}w`).join(", ")} sizes={sizes} alt={alt} decoding="async" {...resto} />;
}
